import Dao from '@/utils/dao'

const state = {
  formSchema: Dao.get('formSchema') || {
    type: 'object',
    title: 'create form',
    description: 'fuse schema',
    properties: {}
  },
  formColumns: Dao.get('formColumns') || [],
  inActiveItem: Dao.get('inActiveItem') || {},
  addItems: Dao.get('addItems') || []
}

const mutations = {
  SET_FORM_SCHEMA: (state, data) => {
    state.formSchema = data

    // 浏览器缓存
    Dao.set('formSchema', data)
  }
}

const actions = {
  // 缓存组装表单的信息
  setFormSchema({ commit }, data) {
    commit('SET_FORM_SCHEMA', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
